import { MESSAGE_TYPES } from '../constants/message.constants';
export const MessageParsers = {
    text: (message, sender) => ({
        sender,
        type: MESSAGE_TYPES.TEXT,
        text: message.text,
        timestamp: message.timestamp,
    }),
    image: (message, sender) => ({
        sender,
        type: MESSAGE_TYPES.IMAGE,
        imageSrc: message.attachment.payload.src,
        alt: message.attachment.payload.alt || '',
        text: message.text,
        timestamp: message.timestamp,
    }),
    accordion: (message, sender) => (Object.assign(Object.assign({ sender }, message), { type: MESSAGE_TYPES.ACCORDION })),
    carousel: (message, sender) => ({
        sender,
        type: MESSAGE_TYPES.CAROUSEL,
        elements: message.elements.map(({ image_url, text, link }) => ({
            text,
            link,
            imageUrl: image_url,
        })),
        timestamp: message.timestamp,
    }),
    quickReply: (message, sender) => ({
        sender,
        type: MESSAGE_TYPES.QUICK_REPLY,
        text: message.text,
        replies: message.quick_replies.map(({ title, payload, isSelected }) => ({
            text: title,
            reply: payload,
            isSelected,
        })),
        timestamp: message.timestamp,
    }),
    fileDownload: (message, sender) => ({
        sender,
        type: MESSAGE_TYPES.FILE_DOWNLOAD,
        fileName: message.file_name,
        fileUrl: message.file_url,
        text: message.text,
        timestamp: message.timestamp,
    }),
    video: (message, sender) => ({
        sender,
        type: MESSAGE_TYPES.VIDEO,
        src: message.video_url,
        timestamp: message.timestamp,
    }),
    rating: (message, sender) => ({
        sender,
        type: MESSAGE_TYPES.RATING,
        text: message.text,
        options: message.options.map(option => ({
            value: option.value,
            payload: option.payload
        })),
        message: message.message,
        timestamp: message.timestamp,
    }),
};
//# sourceMappingURL=message-parsers.js.map